import { cva } from 'class-variance-authority';
import React, { InputHTMLAttributes } from 'react';
import clsx from 'clsx';

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: 'standard' | 'outlined';
  inputSize?: 'small' | 'medium' | 'large';
}

const textInputStyles = cva(
  [
    'text-text-body bg-ui-form-background border-ui-border max-w-form focus:shadow-focus w-full appearance-none rounded border p-2 placeholder-current outline-none',
  ],
  {
    variants: {
      variant: {
        standard: '',
        outlined: '',
      },
      inputSize: {
        small: 'p-1 text-sm',
        medium: 'text-body p-2',
        large: 'text-bodyLg p-3',
      },
    },
    defaultVariants: {
      inputSize: 'medium',
      variant: 'standard',
    },
  },
);

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ variant, inputSize, disabled, className, ...props }, ref) => {
    const classes = clsx(
      textInputStyles({ variant, inputSize, className }),
      disabled && 'text-text-disabled cursor-not-allowed border-ui-disabled',
    );

    return (
      <input {...props} disabled={disabled} className={classes} ref={ref} />
    );
  },
);

TextInput.displayName = 'TextInput';
